// extracted by extract-css-chunks-webpack-plugin
module.exports = {"closeBtn":"closeBtn_ygR9L","ui_mask":"ui_mask_tF2Ex"};